<script>
export default {
  name: 'ScheduleSendModal',
  emits: ['confirm'],
  data() {
    return {
      openState: false,
      draftContent: '',
      draftDateTimeLocal: '',
    };
  },
  methods: {
    open({ content = '' } = {}) {
      this.draftContent = content;
      this.draftDateTimeLocal = ''; // agent must pick
      this.openState = true;
    },
    close() {
      this.openState = false;
    },
    confirm() {
      if (!this.draftContent.trim() || !this.draftDateTimeLocal) return;
      const scheduledAtISO = new Date(this.draftDateTimeLocal).toISOString();
      this.$emit('confirm', { content: this.draftContent.trim(), scheduledAtISO });
      this.close();
    },
  },
};
</script>

<template>
  <div v-if="openState" class="fixed inset-0 z-40 flex items-center justify-center">
    <div class="absolute inset-0 bg-black bg-opacity-40" @click="close" />
    <div class="relative z-50 bg-white dark:bg-slate-800 rounded-lg p-4 w-[460px] shadow-xl">
      <h3 class="text-lg font-semibold mb-3">Schedule message</h3>

      <label class="block text-sm mb-1">Send at</label>
      <input
        type="datetime-local"
        class="w-full border rounded px-3 py-2 mb-3 bg-white dark:bg-slate-700"
        v-model="draftDateTimeLocal"
      />

      <label class="block text-sm mb-1">Message</label>
      <textarea
        class="w-full border rounded px-3 py-2 h-28 bg-white dark:bg-slate-700"
        v-model="draftContent"
      />

      <div class="mt-4 flex justify-end gap-2">
        <button class="px-3 py-2 rounded bg-slate-200 dark:bg-slate-600" @click="close">Cancel</button>
        <button class="px-3 py-2 rounded bg-amber-600 bg-n-brand" :disabled="!draftContent.trim() || !draftDateTimeLocal" @click="confirm">
          Schedule
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* minimal; relies on existing Tailwind/utility classes in project */
</style>

